import { RouteSegments } from '../routingClientAdmin.interface';

export const generateCoreSymbolRoute = (id?: number | string) => {
  const pageUrl = `/${RouteSegments.Root.Config}/${RouteSegments.Config.Symbols}/${RouteSegments.Symbols.Core}`;

  if (id) {
    return `${pageUrl}/${id}`;
  }

  return pageUrl;
};
